export default __webpack_public_path__ + "static/media/ic_stmatic_40.aa815697.svg";